import { VetologyBase } from '../Vetology/VetologyBase'

export class LionList extends VetologyBase
{
    constructor ()
    {
        super('LionList')
    }

    init ()
    {
        const _self = this
        _self.initEventHandlers()

    }

    initEventHandlers ()
    {
        const _self = this

        _self.onShowSettingsClicked = _self.onShowSettingsClicked.bind(_self);

        const showSettingsButtonsContainer = document.querySelector('table.table tbody');
        showSettingsButtonsContainer.addEventListener('click', _self.onShowSettingsClicked)

    }

    removeEventHandlers ()
    {
        const _self = this

        const showSettingsButtons = document.querySelectorAll('table.table tbody tr td.lion-settings')
        showSettingsButtons.forEach(td => {
            const button = td.querySelector('a.btn')
            button.removeEventListener('click', _self.onShowSettingsClicked)
        })

    }

    onShowSettingsClicked (event)
    {
        const _self = this
        const target = event.target;

        if (target.classList.contains('show-settings-btn')) {
            const queryString = new URLSearchParams({
                lionID: target.dataset.lion_id
            })

            fetch('/lions-manager/manage/get-lion-settings/?' + queryString.toString(), {
                method: 'get'
            }).then(response => {
                if (!response.ok) {
                    toastr.error('Could not retrieve lion settings at this time')
                } else {
                    response.json().then(data => {
                        if (!data.success) {
                            toastr.error('Could not find Lion Client')
                            return false;
                        }
                        let modal = document.body.querySelector('div.modal.lion-settings');
                        if (!modal) {
                            modal = _self.getModalDialog();
                            document.body.appendChild(modal);
                        }
                        const modalBody = modal.querySelector('div.modal-body');
                        modalBody.innerHTML = data.lionSettings;
                        $(modal).modal();

                    })
                }
            })

        }

    }

    getModalDialog()
    {
        const dialog = document.createElement('div');
        dialog.classList.add('modal', 'fade', 'lion-settings');
        dialog.attributes.tabindex = '-1';
        dialog.attributes.role = 'dialog';

        const dialogModal = document.createElement('div');
        dialogModal.classList.add('modal-dialog');
        dialogModal.attributes.role = 'document';
        dialog.appendChild(dialogModal);

        const modalContent = document.createElement('div');
        modalContent.classList.add('modal-content');
        dialogModal.appendChild(modalContent);

        const modalHeader = document.createElement('div');
        modalHeader.classList.add('modal-header');
        modalContent.appendChild(modalHeader);

        const closeBtn = document.createElement('button');
        closeBtn.attributes.type = 'button';
        closeBtn.dataset.dismiss = 'modal';
        closeBtn.attributes['aria-label'] = 'Close';
        closeBtn.attributes['aria-hidden'] = 'true';
        closeBtn.innerHTML = '&times;';
        modalHeader.appendChild(closeBtn);

        const modalTitle = document.createElement('h4');
        modalTitle.classList.add('modal-title');
        closeBtn.appendChild(modalTitle);

        const modalBody = document.createElement('div');
        modalBody.classList.add('modal-body');
        modalContent.appendChild(modalBody);

        const modalFooter = document.createElement('div');
        modalFooter.classList.add('modal-footer');
        modalContent.appendChild(modalFooter);


        return dialog;
    }
}
